import LegalLayout from "../components/LegalLayout";
import { PHONE_DISPLAY } from "../config";

const H = ({ children }) => (
  <h2 className="font-serif text-2xl md:text-3xl text-ciruela mt-10 mb-2">{children}</h2>
);

export default function PoliticaPrivacidad() {
  return (
    <LegalLayout title="Política de privacidad" updated="Junio 2026">
      <p>
        En cumplimiento del Reglamento (UE) 2016/679 General de Protección de Datos (RGPD) y de la Ley
        Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD),
        se informa a los usuarios sobre el tratamiento de sus datos personales.
      </p>

      <H>1. Responsable del tratamiento</H>
      <p>
        Responsable: Lorena Cotano — Matrona y Sexóloga.<br />
        Localidad: Montserrat (Valencia), España.<br />
        Teléfono: {PHONE_DISPLAY}.
      </p>

      <H>2. Datos que recopilamos</H>
      <p>
        A través del formulario de contacto del Sitio Web podemos recopilar: nombre, dirección de correo
        electrónico, la etapa vital indicada (opcional) y el contenido del mensaje que nos envíes.
        También podrás contactar directamente por WhatsApp o teléfono, en cuyo caso se tratarán los datos
        que voluntariamente facilites.
      </p>

      <H>3. Finalidad del tratamiento</H>
      <p>
        Los datos se utilizan exclusivamente para responder a tus consultas, gestionar las solicitudes de
        información o sesiones de acompañamiento y mantener el contacto que tú inicies. No se utilizarán
        para finalidades distintas sin tu consentimiento.
      </p>

      <H>4. Legitimación</H>
      <p>
        La base legal para el tratamiento es el consentimiento que otorgas al enviar tus datos a través
        del formulario o al contactarnos, así como el interés legítimo en atender tu solicitud.
      </p>

      <H>5. Conservación de los datos</H>
      <p>
        Los datos se conservarán durante el tiempo necesario para atender tu solicitud y, posteriormente,
        durante los plazos legalmente exigibles. Cuando dejen de ser necesarios serán suprimidos de forma
        segura.
      </p>

      <H>6. Destinatarios</H>
      <p>
        No se cederán datos a terceros, salvo obligación legal. Los datos podrán estar alojados en
        proveedores de servicios tecnológicos que actúan como encargados del tratamiento con las debidas
        garantías.
      </p>

      <H>7. Tus derechos</H>
      <p>
        Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición,
        limitación del tratamiento y portabilidad de tus datos, dirigiéndote al teléfono de contacto
        indicado. También tienes derecho a presentar una reclamación ante la Agencia Española de
        Protección de Datos (www.aepd.es).
      </p>

      <H>8. Seguridad</H>
      <p>
        Aplicamos las medidas técnicas y organizativas necesarias para garantizar la seguridad de tus
        datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
      </p>
    </LegalLayout>
  );
}
